import React, { createRef, useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Grid from "@material-ui/core/Grid";
import BangladeshFlag from "../assets/imgs/Bangladesh-Flag.jpg";
import UsaIcon from "../assets/imgs/Usa-Icon.png";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";
import {
  Section,
  PageTitleOne,
  CardFifteen,
  ModalFour,
} from "master-react-lib";
import CTAOneSection from "./CTAOneSection";
import Pattern from "../assets/imgs/./Pattern.svg";

import img_1 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-Ashrafi Khatun-14.jpeg";
import img_2 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-BM-Depot- Blind Man-Rubel.jpeg";
import img_3 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-WheelChair2023.jpeg";
import img_4 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-BlanketDrive-Kashem.jpeg";
import img_5 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-Education.jpeg";
import img_6 from "../assets/imgs/Ourprojects/deenconnect-hhc-usa-Health-Ambulence Service.png";
import img_7 from "../assets/imgs/program1/deenconnect-hhc-usa-project-limb.jpeg";

import "../assets/css/style.css";

function OurProjectPage(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // ==== Modals ============//
  const [open_1, setOpen_1] = React.useState(false);
  const handleOpen_1 = () => setOpen_1(true);
  const handleClose_1 = () => setOpen_1(false);

  const [open_2, setOpen_2] = React.useState(false);
  const handleOpen_2 = () => setOpen_2(true);
  const handleClose_2 = () => setOpen_2(false);

  const [open_3, setOpen_3] = React.useState(false);
  const handleOpen_3 = () => setOpen_3(true);
  const handleClose_3 = () => setOpen_3(false);

  const [open_4, setOpen_4] = React.useState(false);
  const handleOpen_4 = () => setOpen_4(true);
  const handleClose_4 = () => setOpen_4(false);

  const [open_5, setOpen_5] = React.useState(false);
  const handleOpen_5 = () => setOpen_5(true);
  const handleClose_5 = () => setOpen_5(false);

  const [open_6, setOpen_6] = React.useState(false);
  const handleOpen_6 = () => setOpen_6(true);
  const handleClose_6 = () => setOpen_6(false);
  // ==== Modals ============//

  const currentProjects = [
    {
      img: img_1,
      titleTop: "",
      flag: BangladeshFlag,
      titleTopLink: "/programt-details",
      title: "Ashrafi Khatun",
      description:
        "9th grade Student, Shibganj, Chapai Nawabbganj, চাঁপাইনবাবগঞ্জ জেলার শিবগঞ্জ উপজেলার কানসাট(ক‍্যাইঠাপাড়া)",
      link: "/limb-support-project-details",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_1,
    },

    {
      img: img_2,
      titleTop: "",
      flag: BangladeshFlag,
      title: "BM Deport Disaster",
      description:
        "Rubel, a victim of BM Depot Fire Explotion.Helping Hand Chattogram inc, USA...",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_2,
    },

    {
      img: img_3,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Kabir Hossian-Comilla",
      description:
        "মানুষ মানুষের জন্য। Helping Hand Inc USA Chattogram এর পক্ষ থেকে গাড়ি এক্সিডেন্টে আহত চান্দিনার( কুমিল্লা)...",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_3,
    },

    {
      img: img_4,
      titleTop: "",
      flag: UsaIcon,
      title: "Winters Blankets",
      description:
        "Drive -NYC- HHC distributed hundereds of warm blankets to Homeless people who are suffering...",
      link: "#",
      Donationbtnlink:
        "https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories",
      onClick: handleOpen_4,
    },

    {
      img: img_5,
      titleTop: "",
      flag: BangladeshFlag,
      title: "HELPING HAND CHATTOGRAM-USA",
      description: "will establish an educational and scholarship program...",
      link: "#",
      Donationbtnlink:
        "https://search.yahoo.com/search?fr=mcafee&type=E210US91213G0&p=google",
      onClick: handleOpen_5,
    },

    {
      img: img_6,
      titleTop: "",
      flag: BangladeshFlag,
      title: "Mobile Medical Units",
      description:
        "bring relief to villagers who are either unable to afford medical care or reside in rural...",
      link: "#",
      Donationbtnlink:
        "https://search.yahoo.com/search?fr=mcafee&type=E210US91213G0&p=google",
      onClick: handleOpen_6,
    },
  ];

  const eventDetails = [
    {
      img: img_1,
      title: "Ashrafi Khatun-9th grade Student, Shibganj, Chapai Nawabbganj",
      Location: "Location: Bangladesh",
      description: (
        <p>
          চাঁপাইনবাবগঞ্জ জেলার শিবগঞ্জ উপজেলার কানসাট(ক‍্যাইঠাপাড়া) অটো চালক
          মোহাম্মদ বাবুর মেয়ে মোসাম্মাৎ আশরাফী খাতুন (14) এবার নবম শ্রেণিতে
          পড়ালেখা করছেন। সাত বছর বয়সে ভুল চিকিৎসার কারনে তার ডান পা উরু থেকে
          কেটে ফেলেন। ডাক্তার সেই থেকে লাঠিতে ভর দিয়েই চলাফেরা করে আসছিলেন। উনি
          মানবিক শওকত হোসেন ভাইয়ের সাথে যোগাযোগ করে হেল্পিং হেন্ডের অর্থায়নে
          সম্পূর্ণ ফ্রীতে কৃত্রিম পা সংযোজন করে দেয়। আনন্দে আত্মহারা আশরাফির পা
          সংযোজন শেষে ২২ দিন পর চট্টগ্রাম থেকে তার পরিবারের কাছে ফিরে এসেছে নতুন
          উদ্দোমে। অনেক দিনের স্বপ্ন চাঁপাইনবাবগঞ্জের নবম শ্রেণীর স্কুল ছাত্রী
          আশরাফি খাতুন (১৪) ক্রাচে ভর না করে পায়ে হেটে স্কুলে যাবেন , নতুন বছরে
          শুরুতে নতুন উদ্দোমে ক্রাচ ছাড়া বাড়ী ফিরল আশরাফি।
        </p>
      ),
      open: open_1,
      handleClose: handleClose_1,
    },
    {
      img: img_2,
      title:
        "BM Deport Disaster : Rubel , a victim of BM Depot Fire Explotion.",
      description: (
        <p>
          Helping Hand Chattogram inc, USA extended a helping hand to those
          killed and injured in the BM depot fire at Sitakunda.
          <br></br>Md. Shahadat Hossain, the covered van driver of Zorarganj
          Union who died in the fire explotion, HSC team visited the victim's
          house in a rural arae of Saidali village of Khaiachhra Union and
          inquired about the family. Shahadat Hossain's mother handed over a
          donation check of Tk 20,000 Helping Hand Chattogram-USA'
          <br></br>
          <br></br>সীতাকুণ্ড'র বিএম ডিপোর অগ্নিকান্ডে নিহত ও আহতদের জন্য
          সাহায্যের হাত বাড়ালো Helping Hand Chattogram inc, USA। অগ্নিকাণ্ডে
          নিহত জোরারগঞ্জ ইউনিয়নের কাভার্ড ভ্যান চালক মোঃ শাহাদাত হোসেন এবং
          খৈয়াছড়া ইউনিয়নের সৈদালী গ্রামের আহত মোঃ রুবেলের বাড়িতে গিয়ে পরিবারের
          খোঁজ খবর নেন।রুবেলের হাতে অনুদানের চেক তুলে দেন Helping Hand
          Chattogram-USA' পরিবার গুলো মানবেতর জীবন যাপন করছে। চিকিৎসার অভাবে আহত
          রুবেলের চোখের দৃষ্টিশক্তি হারিয়ে যাচ্ছে। পানি ঝরছে অনবরত। মা বাবার
          একমাত্র সন্তান রুবেল। তার ঘরে রয়েছে ফুটফুটে একটি ছোট্ট শিশু। পরিবারের
          ভবিষ্যত এবং নিজের জীবন নিয়ে রুবেলের যতো দুশ্চিন্তা । উন্নত চিকিৎসা না
          পেলে দুটি চোখে মা, আদরের সন্তান আর সুন্দর পৃথিবী সে দেখবেনা।
        </p>
      ),
      open: open_2,
      handleClose: handleClose_2,
    },
    {
      img: img_3,
      title: "Kabir Hossian-Comilla",
      description: (
        <p>
          মানুষ মানুষের জন্য। Helping Hand Inc USA Chattogram এর পক্ষ থেকে গাড়ি
          এক্সিডেন্টে আহত চান্দিনার( কুমিল্লা) কবির হোসেনকে হুইল চেয়ার প্রদান
          করা হলো। কবির হোসেন এতদিন ভিক্ষা করতেন। হুইলচেয়ার প্রদান অনুষ্ঠানে
          কবির হোসেনকে ভিক্ষাবৃত্তি ছেড়ে ক্ষুদ্র ব্যবসা শুরু করার জন্য Helping
          Hand Chattogram -পূঁজি হিসেবে আর্থিক সহায়তা প্রদান করেন। আশাকরি কবির
          হোসেন ভিক্ষাবৃত্তি ছেড়ে ক্ষুদ্র ব্যবসা শুরু করতে পারবেন।
        </p>
      ),
      open: open_3,
      handleClose: handleClose_3,
    },
    {
      img: img_4,
      title:
        "Winters Blankets  Drive -NYC- HHC distributed hundereds of warm blankets to Homeless people who are suffering in a freezing temperatures.",
      description: (
        <p>
          In NewYork city we distributed hundereds of warm blankets to Homeless
          people who are suffering in a freezing temperatures.
          <br></br>We support helps orphans, widows, the elderly, those living
          in poverty, refugees, and internally displaced people<br></br>
          <br></br>২০২৩ সালের শুভ নববর্ষের প্রথম দিনে শীতার্ত অসহায় ও দুস্থ
          মানুষের উষ্ণতা দিতে সামাজিক দায়বদ্ধতা থেকে পাশে দাঁড়াল Helping Hand
          Chattogram- USA । নিউইয়র্ক সিটির ম্যানহাটনে গরীব , গৃহহীন অসহায়
          মানুষ যারা ফুটপাতে শুয়ে ভিক্ষা করে জীবন কাটায় তাদের অলিতে গলিতে
          খুঁজে বের করে অসহায় ও দুস্থদের মাঝে শীতবস্ত্র / কম্বল বিতরণ করেন
          মানবতাবাদী প্রবাসী এই সংগঠনটি ।<br></br>বাংলাদেশে বিভিন্ন মানবিক কাজের
          পাশাপাশি যুক্তরাষ্টের এই জনকল্যাণমূলক সেচ্ছাসেবী সংগঠনটি এই কমিউনিটিতে
          বিভিন্ন সামাজিক কাজে অংশগ্রহণ করে আসছে।
        </p>
      ),
      open: open_4,
      handleClose: handleClose_4,
    },

    {
      img: img_5,
      title:
        "HELPING HAND CHATTOGRAM-USA will establish an educational and scholarship program that provides a tool for educating our youth and their families.",
      description: (
        <p>
          Education is the way to empowerment, and HHC ensures that children and
          families know the importance of education. Over 169.9 million people
          in Bangladesh, 31.5% live below poverty line. This is one of the
          world’s poorest, least developed nations.<br></br> A major reason for
          this is poverty, children often start work as young as ten-they must
          start earning their keep. Families are often large to help earn an
          income and parents struggle to provide basic necessities for them.{" "}
          <br></br>
          <br></br>
          However, while its government provides free primary, secondary, and
          tertiary education, access to education is hindered by poverty and
          extreme weather in specific regions of the country.<br></br>
          <br></br>
          ““Educate A Child will reignite the world's commitment to the
          hardest-to reach children, the forgotten children. Our mission is to
          turn attention back to the disadvantaged children of today, who could
          become confident adults tomorrow, able to fulfil their potential, if
          we just give them the opportunity.””
        </p>
      ),
      open: open_5,
      handleClose: handleClose_5,
    },
    {
      img: img_6,
      title:
        "Mobile medical units bring relief to villagers who are either unable to afford medical care or reside in rural areas that oftentimes are unreachable during natural disasters. ",
      description: (
        <p>
          Emergency medical professionals, enabled with ambulatory training,
          increase their capacity to cope with any given emergency through these
          services. This also helps provide a means for patients to successfully
          attend rehabilitation and therapy sessions by securing transportation.
          HHC have a future plan to provide Mobile Medical Unit & Ambulance
          Services.
        </p>
      ),
      open: open_6,
      handleClose: handleClose_6,
    },
  ];

  const bangladeshRef = createRef();
  const usaRef = createRef();

  useEffect(() => {
    setTimeout(() => {
      if (window.location.href.indexOf("#banglades") > -1) {
        bangladeshRef &&
          bangladeshRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (window.location.href.indexOf("#usa") > -1) {
        usaRef && usaRef.current.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    }, 1000);
  }, [bangladeshRef, usaRef]);

  return (
    <div>
      <Header />

      <div className="InnerPageCtn">
        <PageTitleOne Title="Our Projects" color="#fff" />

        <Section
          background="#F6FBFE"
          //ContainerWidth=""
          Spacing="40px"
          Container={
            <div className="SectionContainer" ref={bangladeshRef}>
              <h1 className="2ndTitle">Our Current Projects</h1>
              <div className="devider"></div>

              <div>
                <CardFifteen
                  cardFifteenData={currentProjects}
                  col={4}
                  colSpacing={2}
                  titleColor="#fff"
                  Titlebackground="#0B132B"
                  discriptionColor="#707070"
                  buttonLabel="Read More"
                  //ReadmoreIcon={<ArrowForwardRoundedIcon />}
                  ReadmoreColor="#FF6200"
                  BottomLineColor="#FF6200"
                  BottomLine={true}
                  border="border"
                  titleTopLeftcolor="#FF6200"
                  // == Button Style =====//
                  label="Make a donation"
                  arrowIcon={<ArrowForwardRoundedIcon />}
                  arrowStatus={true}
                  arrowColor="#fff"
                  buttoncolor="#33B651"
                  width="100%"
                  height="50px"
                  slider
                  borderRadius="0px"
                  color="#fff"
                  fontWeight="600"
                  //textAlign="center"
                  Buttonlink="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
                  target="_blank"
                />
              </div>
            </div>
          }
        />

        {/* <Section
          background="#fff"
          //ContainerWidth=""
          Spacing="40px"
          Container={
            <div className='SectionContainer' ref={usaRef}>
              <h1 className='2ndTitle'>Our Previous Projects</h1>
              <div className='devider'></div>

              <div>

                <CardFifteen
                  cardFifteenData={currentProjectsUsa}
                  col={4}
                  colSpacing={2}
                  titleColor="#fff"
                  Titlebackground="#0B132B"
                  discriptionColor="#707070"
                  buttonLabel="Read More"
                  //ReadmoreIcon={<ArrowForwardRoundedIcon />}
                  ReadmoreColor="#FF6200"
                  BottomLineColor="#FF6200"
                  BottomLine={true}
                  border="border"
                  titleTopLeftcolor="#FF6200"

                  // == Button Style =====//
                  label="Make a donation"
                  Buttonlink="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
                  target="_blank"
                  arrowIcon={<ArrowForwardRoundedIcon />}
                  arrowStatus={true}
                  arrowColor="#fff"
                  buttoncolor="#33B651"
                  width="100%"
                  height="50px" slider
                  borderRadius="0px"
                  color="#fff"
                  fontWeight="600"
                //textAlign="center"
                />

              </div>
            </div>
          }
        /> */}

        {eventDetails.map((item, i) => (
          <ModalFour
            open={item.open}
            handleClose={item.handleClose}
            width="100%"
            height="750px"
            title="Project details"
            img={item.img}
            imgstatus={true}
            // location="New York, United States"
            // Program="Covid-19"
            // Programlink="/programt-details"

            buttonlabel="DONATE NOW"
            buttoncolor="#33B651"
            buttonarrowStatus="true"
            buttonarrowColor="#fff"
            color="#fff"
            buttonlink="https://myababil.com/f/hhcusa?utm_source=myababil&utm_medium=web-hhcusa-btn-donate-now&utm_campaign=fundraising-categories"
            target="_blank"
            buttonwidth="80%"
            buttonheight="40px"
            ButtonRadius="4px"
            textAlign="center"
            // LocationStatus={true}
            // eventTitle="Personal protective equipment (PPE)"
            // eventTitleStatus={true}

            body={
              <div>
                <h2>{item.title}</h2>
                {/* <h3>{item.Location}</h3> */}
                <p>{item.description}</p>
              </div>
            }
          />
        ))}

        <CTAOneSection />
      </div>
      <Footer />
    </div>
  );
}

export default OurProjectPage;
